import Head from 'next/head';
import Badges from '@/components/Badges';
import { BadgesCode } from '@/components/codeHighlights/BadgesCode';

const Page = () => {
  return (
    <>
      <Head>
        <title>Badges</title>
      </Head>

      <h1>Badges</h1>
      <div className="mt-5">
        <Badges />
      </div>
      <div className="mt-5">
        <h2>Badges HTML-Code Example</h2>
        <BadgesCode />
      </div>
    </>
  );
};

export default Page;
